import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';
import Layout from './components/Layout';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import { useAuthStore } from './store/authStore';
import { useCartStore } from './store/cartStore';
import { LoadingProvider } from './context/LoadingContext';
import { PWAInstallProvider } from './context/PWAInstallContext';


function App() {
  const { checkAuth, isAuthenticated } = useAuthStore();
  const { fetchCart } = useCartStore();

  // Check authentication and fetch cart on mount
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  // Fetch cart when authenticated
  useEffect(() => {
    if (isAuthenticated) {
      fetchCart();
    }
  }, [isAuthenticated, fetchCart]);

  return (
    <ErrorBoundary>
      <LoadingProvider>
        <PWAInstallProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Layout />
          </BrowserRouter>
        </PWAInstallProvider>
      </LoadingProvider>
    </ErrorBoundary>
  );
}

export default App;
